import React from "react";

export default function AddFundsOptionsPopup({
  topupOptions,
  selectedPax,
  startStripeTopUp,
  onOther,
  onClose,
}) {
  return (
    <div className="popup-wrapper" onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <div className="popup-header">
          <span>Amount you wish to add?</span>
          <button className="popup-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div
          className="popup-body"
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "15px",
            flexWrap: "wrap",
            marginTop: "10px",
          }}
        >
          {topupOptions.map((amount) => (
            <button
              key={amount}
              style={{
                padding: "12px 24px",
                backgroundColor: "#6772E5",
                color: "white",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontSize: "16px",
                minWidth: "70px",
              }}
              onClick={() => startStripeTopUp(amount, selectedPax)}
            >
              £{amount}
            </button>
          ))}

          <button
            onClick={onOther}
            style={{
              padding: "12px 24px",
              backgroundColor: "#6772E5",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "16px",
              minWidth: "100px",
            }}
          >
            Other
          </button>
        </div>
      </div>
    </div>
  );
}
